
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, IJobCode, IJobCodeExtended, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * JobCodeService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class JobCodeService {
    private readonly $apiService = inject(ApiService);
    
    GetAllJobCodes(): Promise<IdValuePair[]> {
        return this.$apiService.sendAuth("IJobCodeService/GetAllJobCodes");
    }
    GetDefaultJobCodeForActionType(actionType: string): Promise<IJobCode> {
        return this.$apiService.sendAuth("IJobCodeService/GetDefaultJobCodeForActionType", actionType);
    }
    GetJobCodesForActionType(actionType: string): Promise<IJobCodeExtended[]> {
        return this.$apiService.sendAuth("IJobCodeService/GetJobCodesForActionType", actionType);
    }
    GetJobCodesForServiceOrders(): Promise<IdValuePair[]> {
        return this.$apiService.sendAuth("IJobCodeService/GetJobCodesForServiceOrders");
    }
    LookupJobCode(pCriteria: LookupCriteria): Promise<IJobCode[]> {
        return this.$apiService.sendAuth("IJobCodeService/LookupJobCode", pCriteria);
    }
}
